import { setSpecificMessage, ip } from "valibot";
setSpecificMessage(
  ip,
  (issue) => `IP invalide: reçu ${issue.received}`,
  "fr"
);